import { ArrowLeft } from "lucide-preact";
import type { ComponentChildren } from "preact";

export type SettingsPanelProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ComponentChildren;
};

/** A settings page that slides in over the menu. */
export const SettingsPanel = ({ isOpen, onClose, children }: SettingsPanelProps) => (
  <div class={`transition-all duration-300 ease-in-out ${isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0 pointer-events-none absolute"}`}>
    <button
      type="button"
      onClick={onClose}
      class="flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors mb-3"
    >
      <ArrowLeft size={24} />
      <span class="text-lg font-medium">Settings</span>
    </button>
    <div>{children}</div>
  </div>
);
